<script lang="ts">var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var _a, _b, _c, _d, _e, _f, _g, _h, _j;
import { YinzCamCardsServiceElement } from 'yinzcam-cards';
import CardBase from '../../../common/CardBase.svelte';
import { Readable } from 'svelte/store';
import { CardsDataSourceRegistration } from '../../../common/CardsDataSourceRegistration';
import { CardsTabContext, CardsTabContextKey } from '../../../common/context';
import { getContext } from 'svelte';
import { JanusSignonManager, JanusSignonManagerToken } from "../../../../../js/sso";
import { getToken } from 'inversify-token';
import ROOT from '../../../../../inversify.config';
import { onMount } from 'svelte/internal';
const signonManager = getToken(ROOT, JanusSignonManagerToken);
export let element;
export let sources;
export let sourceStore;
const tabContext = getContext(CardsTabContextKey);
$: mergedParams = (_a = tabContext === null || tabContext === void 0 ? void 0 : tabContext.mergedParamsComp) === null || _a === void 0 ? void 0 : _a.store;
$: key = (_b = element === null || element === void 0 ? void 0 : element.data) === null || _b === void 0 ? void 0 : _b.key;
$: text = (_c = element === null || element === void 0 ? void 0 : element.data) === null || _c === void 0 ? void 0 : _c.text;
$: default_checked = ((_d = element === null || element === void 0 ? void 0 : element.data) === null || _d === void 0 ? void 0 : _d.default_checked) || false;
$: profileField = ((_e = element === null || element === void 0 ? void 0 : element.data) === null || _e === void 0 ? void 0 : _e.profileField) || key;
$: addressKey = (_f = element === null || element === void 0 ? void 0 : element.data) === null || _f === void 0 ? void 0 : _f.addressKey;
$: rawTextByCountry = (_g = element === null || element === void 0 ? void 0 : element.data) === null || _g === void 0 ? void 0 : _g.textByCountry;
$: rawHideCheckboxCountries = (_h = element === null || element === void 0 ? void 0 : element.data) === null || _h === void 0 ? void 0 : _h.hideCheckboxCountries;
$: hiddenCheckedValue = (_j = element === null || element === void 0 ? void 0 : element.data) === null || _j === void 0 ? void 0 : _j.hiddenCheckedValue;
const safeParseJson = (value) => {
    if (typeof value !== 'string')
        return undefined;
    try {
        return JSON.parse(value);
    }
    catch (_a) {
        return undefined;
    }
};
const getAddressCountry = (addressJson) => {
    const addressObj = typeof addressJson === 'string' ? safeParseJson(addressJson) : addressJson;
    const country = addressObj === null || addressObj === void 0 ? void 0 : addressObj.address_country;
    return typeof country === 'string' ? country : '';
};
const normalizeCountryList = (value) => {
    if (!value)
        return [];
    if (Array.isArray(value))
        return value.map(v => (typeof v === 'string' ? v.trim() : '')).filter(Boolean);
    if (typeof value === 'string')
        return value.split(',').map(v => v.trim()).filter(Boolean);
    return [];
};
$: textByCountry =
    typeof rawTextByCountry === 'string'
        ? (safeParseJson(rawTextByCountry) || {})
        : (rawTextByCountry || {});
$: selectedCountry = addressKey ? getAddressCountry(($mergedParams || {})[addressKey]) : '';
const findTextForCountry = (country, map) => {
    if (!country || !map || typeof map !== 'object')
        return undefined;
    if (typeof map[country] === 'string')
        return map[country];
    for (const rawKey of Object.keys(map)) {
        const countries = rawKey.split(',').map(v => v.trim()).filter(Boolean);
        if (countries.includes(country) && typeof map[rawKey] === 'string') {
            return map[rawKey];
        }
    }
    return undefined;
};
$: resolvedText = findTextForCountry(selectedCountry, textByCountry) || text;
$: hideCheckboxCountries = normalizeCountryList(rawHideCheckboxCountries);
$: isCheckboxHidden = !!(selectedCountry && hideCheckboxCountries.includes(selectedCountry));
let checked = false;
$: if (isCheckboxHidden && (hiddenCheckedValue === 'true' || hiddenCheckedValue === 'false')) {
    const nextChecked = hiddenCheckedValue === 'true';
    if (checked !== nextChecked) {
        checked = nextChecked;
        tabContext.setParam(key, checked + "");
    }
}
const onClick = (e) => {
    console.log('value: ', checked, checked + "");
    tabContext.setParam(key, checked + "");
};
onMount(() => __awaiter(void 0, void 0, void 0, function* () {
    let data = {};
    try {
        const profileData = yield signonManager.getUserProfileSegment();
        data = (profileData === null || profileData === void 0 ? void 0 : profileData.data) || {};
    }
    catch (_k) {
        data = {};
    }
    if (profileField in data) {
        checked = (data[profileField] || '').toLowerCase() === "true";
    }
    else {
        checked = default_checked;
    }
    console.log('optin: ', data, data[profileField]);
    tabContext.setParam(key, checked + "");
}));
</script>
  <CardBase {element}>
    <div class="sms-optin-wrapper">
      {#if !isCheckboxHidden}
        <div class="round">
          <input type="checkbox" id={key} bind:checked on:change={onClick} />
          <label for={key} />
        </div>
      {/if}
      <label for={key} class="text" class:no-checkbox={isCheckboxHidden}>
          {@html resolvedText}
      </label>
    </div>
  </CardBase>
  <style>.sms-optin-wrapper {
  display: flex;
  align-items: flex-start;
}

.sms-optin-wrapper :global(.link) {
  text-decoration: none;
  color: var(--alav-s-primary);
}

.text {
  text-align: left;
  margin-left: 11px;
  font-style: normal;
  font-weight: 400;
  font-size: 12px;
  line-height: 16px;
  color: #898989;
}

.text.no-checkbox {
  margin-left: 0;
}

.round {
  position: relative;
  height: 18px;
  width: 18px;
}

.round label {
  background-color: transparent;
  border: 1px solid #D8D8D8;
  border-radius: 6px;
  cursor: pointer;
  position: absolute;
  top: 0; left: 0;
  height: 18px;
  width: 18px;
}

.round label:after {
  border: 2px solid #fff;
  border-top: none;
  border-right: none;
  content: "";
  opacity: 0;
  position: absolute;
  transform: rotate(-45deg);
  height: 5px;
  width: 9px;
  top: 3px;
  left: 3px;
}

.round input[type="checkbox"] {
  visibility: hidden;
  margin: 0;
}

.round input[type="checkbox"]:checked + label {
  background-color: var(--alav-s-primary);
  border-color: var(--alav-s-primary);
}

.round input[type="checkbox"]:checked + label:after {
  opacity: 1;
}</style>
  